import type { MemberCode } from '@/types/waterfall'

export interface CapitalContributionsSyncIgnore {
  date: string
  member: MemberCode
  amount: number
}

export function parseSyncIgnores(value: unknown): CapitalContributionsSyncIgnore[] {
  if (!Array.isArray(value)) return []
  const out: CapitalContributionsSyncIgnore[] = []
  for (const entry of value) {
    if (!entry || typeof entry !== 'object') continue
    const date = (entry as { date?: unknown }).date
    const member = (entry as { member?: unknown }).member
    const amount = (entry as { amount?: unknown }).amount
    if (typeof date !== 'string' || typeof member !== 'string' || typeof amount !== 'number') {
      continue
    }
    out.push({ date, member: member as MemberCode, amount })
  }
  return out
}

export function addSyncIgnore(
  ignores: CapitalContributionsSyncIgnore[],
  entry: CapitalContributionsSyncIgnore,
): CapitalContributionsSyncIgnore[] {
  const filtered = ignores.filter(
    (ignore) => !(ignore.date === entry.date && ignore.member === entry.member),
  )
  return [...filtered, entry]
}

export function removeSyncIgnore(
  ignores: CapitalContributionsSyncIgnore[],
  date: string,
  member: string,
): CapitalContributionsSyncIgnore[] {
  return ignores.filter((ignore) => !(ignore.date === date && ignore.member === member))
}

export function hasNonzeroProposedAmount(amount: number): boolean {
  return Math.abs(amount) > 0.005
}
